import React from "react";
import { Row, Col, OverlayTrigger, Tooltip } from "react-bootstrap";

import { FORM_FIELD_KEYS } from "../../../../../constants/forms";
import { getFieldProps } from "../../../../../utils/form-fields";

import TextInput from "../../../controls/TextInput";
import MaskInput from "../../../controls/MaskInput";
import Select from "../../../controls/Select";

function PrimaryPartnerInfoBlock({ values = {}, onChange, onMouseEnter, onMouseLeave }) {
  return (
    <Row>
      <Col xs={12}>
        <div className="inputs-block-title">
          <span>Primary Partner Information</span>
        </div>
      </Col>
      <Col xs={12}>
        <Select
          {...getFieldProps(FORM_FIELD_KEYS.primaryPartnerTitle)}
          placeholder={getFieldProps(FORM_FIELD_KEYS.primaryPartnerTitle)?.placeholder?.replace("*", "")}
          value={values[FORM_FIELD_KEYS.primaryPartnerTitle]}
          validated={values.validated}
          onChange={onChange}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
        />
      </Col>
      <Col xs={12}>
        <TextInput
          {...getFieldProps(FORM_FIELD_KEYS.primaryPartnerFirstName)}
          placeholder={getFieldProps(FORM_FIELD_KEYS.primaryPartnerFirstName)?.placeholder?.replace("*", "")}
          value={values[FORM_FIELD_KEYS.primaryPartnerFirstName]}
          onChange={onChange}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
        />
      </Col>
      <Col xs={12}>
        <TextInput
          {...getFieldProps(FORM_FIELD_KEYS.primaryPartnerMiddleName)}
          placeholder={getFieldProps(FORM_FIELD_KEYS.primaryPartnerMiddleName)?.placeholder?.replace("*", "")}
          value={values[FORM_FIELD_KEYS.primaryPartnerMiddleName]}
          onChange={onChange}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
        />
      </Col>
      <Col xs={12}>
        <TextInput
          {...getFieldProps(FORM_FIELD_KEYS.primaryPartnerLastName)}
          placeholder={getFieldProps(FORM_FIELD_KEYS.primaryPartnerLastName)?.placeholder?.replace("*", "")}
          value={values[FORM_FIELD_KEYS.primaryPartnerLastName]}
          onChange={onChange}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
        />
      </Col>
      <Col xs={12}>
        <Select
          {...getFieldProps(FORM_FIELD_KEYS.primaryPartnerSuffixName)}
          placeholder={getFieldProps(FORM_FIELD_KEYS.primaryPartnerSuffixName)?.placeholder?.replace("*", "")}
          value={values[FORM_FIELD_KEYS.primaryPartnerSuffixName]}
          validated={values.validated}
          onChange={onChange}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
        />
      </Col>
      <Col xs={12}>
        <MaskInput
          {...getFieldProps(FORM_FIELD_KEYS.primaryPartnerSSN)}
          label={(
            <>
              Social Security Number&nbsp;
              <OverlayTrigger
                placement="top"
                delay={{ show: 0, hide: 0 }}
                trigger={["hover", "click"]}
                overlay={(
                  <Tooltip id={`tooltip-${FORM_FIELD_KEYS.primaryPartnerSSN}-subhint`} className="subhintTooltipFederal">
                    <span>
                      In order to assign an EIN for an Entity, the IRS requires the Social Security Number of the managing member. 
                      This information is secured with SSL encryption.
                    </span>
                  </Tooltip>
                )}
              >
                <a className="ssn-subhint-title">
                  Why is this needed?
                </a>
              </OverlayTrigger>
            </>
          )}
          placeholder={getFieldProps(FORM_FIELD_KEYS.primaryPartnerSSN)?.placeholder?.replace("*", "")}
          value={values[FORM_FIELD_KEYS.primaryPartnerSSN]}
          onChange={onChange}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
          hideDivider
        />
      </Col>
      <Col xs={12}>
        <div className="inputs-block-divider" />
      </Col>
    </Row>
  );
}

export default PrimaryPartnerInfoBlock;
